import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {floorEdit_template} from "../components/templates/floorEdit_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class floor_edit extends vnModule_knockoutJS{

    protected requestHandler: XMLHttpRequestHandler;
    protected template: floorEdit_template;

    /**
     * @inheritDoc
     */
    protected getModuleName(){

        return 'floor_edit';
    }

    /**
     * @inheritDoc
     */
    public buildContent(): Array<Element>{

        let id = this.getVnAppZone().app.params.id;

        let zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        let loadedModule = zoneHeader.loadedModule;

        if(id){
            (<header>loadedModule).setHeaderTitle('Edit Floor');
        }
        else{
            (<header>loadedModule).setHeaderTitle('Add Floor');
        }

        this.template = new floorEdit_template('floorEdit_template', this.viewModel, this);

        return [this.template.build()];
    }

    /**
     * @inheritDoc
     */
    public fillPage(): void{

        this.getEditFormData();
    }

    //
    // Hook.
    // Cancels the edits to a user.
    protected cancel(){

        this.loadingIn(this.template.builtTemplate);

        this.releaseLock();

        // Redirect to earnings page or user list.
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, 'Floor action canceled!');

        let idBrand = this.getVnAppZone().app.params.idBrand;

        if(idBrand){
            
            page.redirect(`/brand/${idBrand}/floors/`);
        }
        else{

            page.redirect(`/floors/`);
        }
    }

    //
    // Requests a lock release.
    protected releaseLock(): void{

        let id      = this.getVnAppZone().app.params.id;
        let idBrand = this.getVnAppZone().app.params.idBrand;
        let url     = '';

        if(!id){

            return;
        }

        if(idBrand){

            url = `/brand/${idBrand}/floors/${this.getVnAppZone().app.params.id}/release_lock/`;
        }
        else{

            url = `/floors/${this.getVnAppZone().app.params.id}/release_lock/`;
        }

        // Request a lock release.
        this.requestHandler = new XMLHttpRequestHandler(url, [], this);
        this.requestHandler.execute();
    }

    //
    // Obtain the dynamic data required to fill the form.
    protected getEditData(takeover: boolean = false): void{

        this.loadingIn(this.template.builtTemplate);

        let id      = this.getVnAppZone().app.params.id;
        let idBrand = this.getVnAppZone().app.params.idBrand;
        let url     = '';

        if(!id){

            this.loadingOut(this.template.builtTemplate);
            return;
        }

        if(idBrand){

            url = `/api/brand/${idBrand}/floors/get/${id}`;
        }
        else{

            url = `/api/floors/get/${id}`;
        }

        this.requestHandler = new XMLHttpRequestHandler(url, [['takeover', (takeover) ? '1' : '0']], this);
        this.requestHandler.onReadyStateFunction = this.onEditDataRequestReturn;
        this.requestHandler.execute();
    }

    //
    // Handles the form data response.
    protected onEditDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateEditData(responseParsed);
                obj.loadingOut(obj.template.builtTemplate);
            });
        }
    }

    //
    // Updates the form elements.
    protected updateEditData(responseParsed: any){

        this.template.setFormData(responseParsed);
    }

    //
    // Hook.
    // Saves the user data.
    protected save(): void{

        this.loadingIn(this.template.builtTemplate);

        let subViewModel = this.template.getViewModelForRequest();

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(subViewModel)] );

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let url     = '';

        if(idBrand){

            url = `/api/brand/${idBrand}/floors/save/`;
        }
        else{

            url = `/api/floors/save/`;
        }

        let requestHandler:XMLHttpRequestHandler = new XMLHttpRequestHandler(url, params, this);
        requestHandler.mode                      = XMLHttpRequestHandler_requestType.POST;
        requestHandler.onReadyStateFunction      = this.onSaveReturn;
        requestHandler.execute();
    }

    //
    // Handles save response.
    protected onSaveReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Floor saved successfully!');
                obj.releaseLock();

                let idBrand = obj.getVnAppZone().app.params.idBrand;

                if(idBrand){
                    
                    page.redirect(`/brand/${idBrand}/floors/`);
                }
                else{

                    page.redirect(`/floors/`);
                }
            });

            obj.loadingOut(obj.template.builtTemplate);
        }
    }

    //
    // Obtain the dynamic data required to fill the form.
    protected getEditFormData(): void{

        this.loadingIn(this.template.builtTemplate);

        let idBrand = this.getVnAppZone().app.params.idBrand;
        let url     = '';

        if(idBrand){

            url = `/api/brand/${idBrand}/floors/references/`;
        }
        else{
            
            url = `/api/floors/references/`;
        }

        this.requestHandler = new XMLHttpRequestHandler(url, [], this);
        this.requestHandler.onReadyStateFunction = this.onEditFormDataRequestReturn;
        this.requestHandler.execute();
    }

    //
    // Returns handler for edit form request.
    protected onEditFormDataRequestReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateEditFormData(responseParsed);
                obj.loadingOut(obj.template.builtTemplate);
                obj.getEditData();
            });
        }
    }

    //
    // Update the filters.
    protected updateEditFormData(responseParsed: any): void{

        let adSetups = [];
            
        adSetups = responseParsed.adSetups || [];
        adSetups.unshift({id: 0, name: 'All'});

        this.template.getTemplateViewModel().adSetups(adSetups);
           
        let desktopAdSetups = responseParsed.desktopAdSetups || [];
        desktopAdSetups.unshift({id: 0, name: 'All'});

        this.template.getTemplateViewModel().desktopAdSetups(desktopAdSetups);

        let mobileAdSetups = responseParsed.mobileAdSetups || [];
        mobileAdSetups.unshift({id: 0, name: 'All'});

        this.template.getTemplateViewModel().mobileAdSetups(mobileAdSetups);

        let deviceTypes = responseParsed.deviceTypes || [];
        deviceTypes.unshift({id: 0, name: 'All'});

        this.template.getTemplateViewModel().deviceTypes(deviceTypes);

        let geos = responseParsed.geos || [];
        geos.unshift({id: 0, name: 'All'});

        let zones = responseParsed.zones || [];
        zones.unshift({id: 0, name: 'All'});

        let mediaTypes = responseParsed.mediaTypes || [];
        mediaTypes.unshift({id: 0, name: 'All'});

        let dimensions = responseParsed.dimensions || [];
        dimensions.unshift({id: 0, name: 'All'});

        let bidderTypes = responseParsed.bidderTypes || [];
        bidderTypes.unshift({id: 0, name: 'All'});

        let bidders = responseParsed.bidders || [];

        bidders.map(bidder =>{

            bidder.name = bidder.displayName || bidder.name;
        });

        bidders.sort((bidderA, bidderB) =>{
            
            return bidderA.name.localeCompare(bidderB.name);
        });

        bidders.unshift({id: 0, name: 'All'});

        let amazonBidders = responseParsed.amazonBidders || [];

        amazonBidders.map(bidder =>{

            bidder.name = bidder.displayName || bidder.name;
        });

        amazonBidders.sort((bidderA, bidderB) =>{
            
            return bidderA.name.localeCompare(bidderB.name);
        });

        amazonBidders.unshift({id: 0, name: 'All'});

        let prebidBidders = responseParsed.prebidBidders || [];

        prebidBidders.map(bidder =>{

            bidder.name = bidder.displayName || bidder.name;
        });

        prebidBidders.sort((bidderA, bidderB) =>{
            
            return bidderA.name.localeCompare(bidderB.name);
        });

        prebidBidders.unshift({id: 0, name: 'All'});

        this.template.getTemplateViewModel().bidderTypes(bidderTypes);
        this.template.getTemplateViewModel().bidders(bidders);
        this.template.getTemplateViewModel().amazonBidders(amazonBidders);
        this.template.getTemplateViewModel().prebidBidders(prebidBidders);
        this.template.getTemplateViewModel().zones(zones);

        this.template.destinationFilter.setOptions(responseParsed.destinations);
        this.template.destinationFilter.getTemplateViewModel().selectedOption(0);
        this.template.adSetupFilter.setOptions(adSetups);
        this.template.adSetupFilter.getTemplateViewModel().selectedOption(0);
        this.template.deviceTypeFilter.setOptions(deviceTypes);
        this.template.deviceTypeFilter.getTemplateViewModel().selectedOption(0);
        this.template.geoFilter.setOptions(geos);
        this.template.geoFilter.getTemplateViewModel().selectedOption(0);
        this.template.zoneFilter.setOptions(zones);
        this.template.zoneFilter.getTemplateViewModel().selectedOption(0);
        this.template.mediaTypeFilter.setOptions(mediaTypes);
        this.template.mediaTypeFilter.getTemplateViewModel().selectedOption(0);
        this.template.dimensionsFilter.setOptions(dimensions);
        this.template.dimensionsFilter.getTemplateViewModel().selectedOption(0);
        this.template.bidderTypeFilter.setOptions(bidderTypes);
        this.template.bidderTypeFilter.getTemplateViewModel().selectedOption(0);
        this.template.bidderFilter.setOptions(bidders);
        this.template.bidderFilter.getTemplateViewModel().selectedOption(0);

        if(responseParsed.brand){

            this.template.getTemplateViewModel().idBrand(responseParsed.brand.id);
            this.template.getTemplateViewModel().brandName(responseParsed.brand.name);        
        }
    }

    /** @inheritDoc */
    public confirmationModalOnClickConfirm(context, data): void{

        if('saveModal' === context){

            this.save();
            return;
        }

        this.getEditData(true);
    }

    /** @inheritDoc */
    public confirmationModalOnClickClose(context, data): void{

        page.redirect(data);
    }

    //
    // Hook.
    public filterDropdownOnChange(id): void{
        
        if('destinationFilter' === id){

            let selectedOption = this.template.destinationFilter.getTemplateViewModel().selectedOption();

            if(2 === selectedOption){

                this.template.getTemplateViewModel().showBidder(true);
            }
            else{

                this.template.bidderFilter.getTemplateViewModel().selectedOption(0);
                this.template.getTemplateViewModel().showBidder(false);
            }
        }

        let selectedOptionDeviceTypeFilter = this.template.deviceTypeFilter.getTemplateViewModel().selectedOption();
        let selectedOptionAdSetupFilter    = this.template.adSetupFilter.getTemplateViewModel().selectedOption();
        let selectedOptionBidderTypeFilter = this.template.bidderTypeFilter.getTemplateViewModel().selectedOption();
        let selectedOptionBidderFilter     = this.template.bidderFilter.getTemplateViewModel().selectedOption();

        let adSetups        = this.template.getTemplateViewModel().adSetups();
        let selectedAdSetup = adSetups.find(function(adSetup){

            return adSetup.id === selectedOptionAdSetupFilter;
        });

        let deviceTypes        = this.template.getTemplateViewModel().deviceTypes();
        let selectedDeviceType = deviceTypes.find(function(deviceType){

            return deviceType.id === selectedOptionDeviceTypeFilter;
        });

        let bidderTypes        = this.template.getTemplateViewModel().bidderTypes();
        let selectedBidderType = bidderTypes.find(function(bidderType){

            return bidderType.id === selectedOptionBidderTypeFilter;
        });

        let bidders        = this.template.getTemplateViewModel().bidders();
        let selectedBidder = bidders.find(function(bidder){

            return bidder.id === selectedOptionBidderFilter;
        });

        if('deviceTypeFilter' === id){            

            if(0 !== selectedDeviceType.id && selectedAdSetup && 0 !== selectedAdSetup.id && selectedAdSetup.device.toLowerCase() !== selectedDeviceType.name.toLowerCase()){
                
                this.template.adSetupFilter.getTemplateViewModel().selectedOption(0);
                this.template.deviceTypeFilter.setDisable(false);
            }

            if(1 === selectedOptionDeviceTypeFilter){

                this.template.adSetupFilter.setOptions(this.template.getTemplateViewModel().desktopAdSetups());
            }
            else if(2 === selectedOptionDeviceTypeFilter){

                this.template.adSetupFilter.setOptions(this.template.getTemplateViewModel().mobileAdSetups());
            }
            else if (0 === selectedOptionDeviceTypeFilter){

                this.template.adSetupFilter.setOptions(this.template.getTemplateViewModel().adSetups());
                this.template.deviceTypeFilter.setDisable(false);
            }
        }

        if('adSetupFilter' === id){

            if(0 === selectedAdSetup.id && selectedAdSetup.device !== selectedDeviceType.name){
                
                this.template.deviceTypeFilter.setDisable(false);
            }

            let selectedAdSetupDeviceName = selectedAdSetup.device;
            selectedAdSetupDeviceName     = (selectedAdSetupDeviceName) ? selectedAdSetupDeviceName.toLowerCase() : selectedAdSetupDeviceName;

            if('desktop' === selectedAdSetupDeviceName){

                this.template.deviceTypeFilter.getTemplateViewModel().selectedOption(1);
                this.template.deviceTypeFilter.setDisable(true);
            }
            else if('mobile' === selectedAdSetupDeviceName){

                this.template.deviceTypeFilter.getTemplateViewModel().selectedOption(2);
                this.template.deviceTypeFilter.setDisable(true);
            }
        }

        if('bidderTypeFilter' === id){

            if(0 !== selectedBidderType.id && selectedBidder && 0 !== selectedBidder.id && selectedBidder.type.id !== selectedBidderType.id){
                
                this.template.bidderFilter.getTemplateViewModel().selectedOption(0);
                this.template.bidderTypeFilter.setDisable(false);
            }

            if(1 === selectedOptionBidderTypeFilter){

                this.template.bidderFilter.setOptions(this.template.getTemplateViewModel().prebidBidders());
            }
            else if(2 === selectedOptionBidderTypeFilter){

                this.template.bidderFilter.setOptions(this.template.getTemplateViewModel().amazonBidders());
            }
            else if (0 === selectedOptionBidderTypeFilter){

                this.template.bidderFilter.setOptions(this.template.getTemplateViewModel().bidders());
                this.template.bidderTypeFilter.setDisable(false);
            }
        }

        if('bidderFilter' === id){

            if(0 === selectedBidder.id){
                
                this.template.bidderTypeFilter.setDisable(false);
            }
            else if(1 === selectedBidder.type.id){

                this.template.bidderTypeFilter.getTemplateViewModel().selectedOption(1);
                this.template.bidderTypeFilter.setDisable(true);
            }
            else if(2 === selectedBidder.type.id){

                this.template.bidderTypeFilter.getTemplateViewModel().selectedOption(2);
                this.template.bidderTypeFilter.setDisable(true);
            }
        }

        if('zoneFilter' === id){

            let selectedZoneOption = this.template.zoneFilter.getTemplateViewModel().selectedOption();
            let zones              = this.template.getTemplateViewModel().zones();
            let slectedZone        = zones.find(function(zone){

                return zone.id === selectedZoneOption;
            });

            this.template.getTemplateViewModel().parentZoneName(slectedZone.nameParent || 'None');
        }
    }
}
